import type { RootState } from '~/redux/store';
import type { Call, Contact, Email, Sms } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export function createContactsSelectors(prefix: string): Record<string, (state: RootState) => unknown> {
  const getColumns = (state: RootState): string[] => {
    const target = prefix === '' ? state.contacts : (state[prefix as keyof RootState] as any).contacts;
    return target.columns.index;
  };

  const getItem = (state: RootState): Contact | null => {
    const target = prefix === '' ? state.contacts : (state[prefix as keyof RootState] as any).contacts;
    return target.item;
  };

  const getParams = (state: RootState): IRestIndexParams<Contact> => {
    const target = prefix === '' ? state.contacts : (state[prefix as keyof RootState] as any).contacts;
    return {
      sortBy: target.sortBy,
      page: target.page,
      pageSize: target.pageSize,
      with: target.with.join(','),
      ...target.filters,
    };
  };

  return {
    getColumns,
    getItem,
    getParams,
  };
}

export function createCallsSelectors(prefix: string): Record<string, (state: RootState) => unknown> {
  const getColumns = (state: RootState): string[] => {
    const target = (state[prefix as keyof RootState] as any).calls;
    return target.columns.index;
  };

  const getItem = (state: RootState): Call | null => {
    const target = (state[prefix as keyof RootState] as any).calls;
    return target.item;
  };

  const getParams = (state: RootState): IRestIndexParams<Call> => {
    const target = (state[prefix as keyof RootState] as any).calls;
    return {
      sortBy: target.sortBy,
      page: target.page,
      pageSize: target.pageSize,
      with: target.with.join(','),
      ...target.filters,
    };
  };

  return {
    getColumns,
    getItem,
    getParams,
  };
}

export function createEmailsSelectors(prefix: string): Record<string, (state: RootState) => unknown> {
  const getColumns = (state: RootState): string[] => {
    const target = (state[prefix as keyof RootState] as any).emails;
    return target.columns.index;
  };

  const getItem = (state: RootState): Email | null => {
    const target = (state[prefix as keyof RootState] as any).emails;
    return target.item;
  };

  const getParams = (state: RootState): IRestIndexParams<Email> => {
    const target = (state[prefix as keyof RootState] as any).emails;
    return {
      sortBy: target.sortBy,
      page: target.page,
      pageSize: target.pageSize,
      with: target.with.join(','),
      ...target.filters,
    };
  };

  return {
    getColumns,
    getItem,
    getParams,
  };
}

export function createSmsSelectors(prefix: string): Record<string, (state: RootState) => unknown> {
  const getColumns = (state: RootState): string[] => {
    const target = (state[prefix as keyof RootState] as any).sms;
    return target.columns.index;
  };

  const getItem = (state: RootState): Sms | null => {
    const target = (state[prefix as keyof RootState] as any).sms;
    return target.item;
  };

  const getParams = (state: RootState): IRestIndexParams<Sms> => {
    const target = (state[prefix as keyof RootState] as any).sms;
    return {
      sortBy: target.sortBy,
      page: target.page,
      pageSize: target.pageSize,
      with: target.with.join(','),
      ...target.filters,
    };
  };

  return {
    getColumns,
    getItem,
    getParams,
  };
}
